<template>
	<div class="full">
		<vxe-grid ref="inventoryTable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			invoicedata: {
				default: () => {
					return {}
				}
			},
			store: {
				default: () => {
					return {}
				}
			},			
		},
		data() {
			return {
				list_footerField:[
					{field:'inAmount',toFixed:4},
					{field:'outAmount',toFixed:4},
					{field:'endAmount',toFixed:4}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},{
						field: 'inventoryName',
						title: '项目名称',
					},
					{
						field: 'unit',
						title: '件',
						width:50
					},
					{
						field: 'inUnitPrice',
						title: '入库单价',
					},
					{
						field: 'inQuantity',
						title: '入库数量',
					},
					{
						field: 'inAmount',
						title: '入库金额',
					},
					{
						field: 'outUnitPrice',
						title: '出库单价',
					},
					{
						field: 'outQuantity',
						title: '出库数量',
					},
					{
						field: 'outAmount',
						title: '出库金额',
					},
					{
						field: 'endQuantity',
						title: '结存数量',
						slots:{
							default:({row})=>{
								if(row.endQuantity<0){
									return <span style="color:#F56C6C">{row.endQuantity}</span>
								}else{
									return row.endQuantity
								}
							}
						}
					},
					{
						field: 'endUnitPrice',
						title: '结存单价',
						slots:{
							default:({row})=>{
								if(row.endAmount<0){
									return <span style="color:#F56C6C">{row.endUnitPrice}</span>
								}else{
									return row.endUnitPrice
								}
							}
						}
					},
					{
						field: 'endAmount',
						title: '结存金额',
						slots:{
							default:({row})=>{
								if(row.endAmount<0){
									return <span style="color:#F56C6C">{row.endAmount}</span>
								}else{
									return row.endAmount
								}
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = false
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.store.inventoryreport
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>